/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { store } from '../models/store';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StoreService {
    /**
     * Get favorite `Store` list of a member.
     *
     * @param memberId Member identifier
     * @param retailerId Retailer identifier
     * @returns store Successful operation, returning found stores.
     * @throws ApiError
     */
    public static getMembersStores(
        memberId: number,
        retailerId?: number,
    ): CancelablePromise<Array<store>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/members/{member_id}/stores',
            path: {
                'member_id': memberId,
            },
            query: {
                'retailer_id': retailerId,
            },
        });
    }
    /**
     * Create a favorite `Store` for a member.
     *
     * @param memberId Member identifier
     * @param store
     * @returns any Successful operation.
     * @throws ApiError
     */
    public static postMembersStores(
        memberId: number,
        store: {
            /**
             * Store identifier
             */
            id?: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/members/{member_id}/stores',
            path: {
                'member_id': memberId,
            },
            body: store,
        });
    }
    /**
     * Delete favorite `Store` of a member.
     *
     * @param memberId Member identifier
     * @param storeId Store identifier
     * @returns any Successful response.
     * @throws ApiError
     */
    public static deleteMembersStores(
        memberId: number,
        storeId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/members/{member_id}/stores/{store_id}',
            path: {
                'member_id': memberId,
                'store_id': storeId,
            },
        });
    }
    /**
     * Get the `Store` list.
     *
     * @param memberId Member identifier to not retrieve favorite stores
     * @param retailerId Retailer identifier
     * @param latitude Latitude to filter around location
     * @param longitude Longitude to filter around location
     * @param nearbyPostcode to filter nearby postcode
     * @param postcode postcode to filter
     * @param prefecture prefecture to filter
     * @param city city to filter
     * @param area area to filter
     * @param perPage Requested count
     * @param page Page number (permits to define offset, start at 1)
     * @returns any Successful operation, returning stores list.
     * @throws ApiError
     */
    public static getStores(
        memberId?: number,
        retailerId?: number,
        latitude?: number,
        longitude?: number,
        nearbyPostcode?: string,
        postcode?: string,
        prefecture?: string,
        city?: string,
        area?: string,
        perPage?: number,
        page?: number,
    ): CancelablePromise<{
        /**
         * total entries length
         */
        total?: number;
        /**
         * returned page (start at 1)
         */
        page?: number;
        /**
         * count entries per page
         */
        per_page?: number;
        items?: Array<store>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/stores',
            query: {
                'member_id': memberId,
                'retailer_id': retailerId,
                'latitude': latitude,
                'longitude': longitude,
                'nearby_postcode': nearbyPostcode,
                'postcode': postcode,
                'prefecture': prefecture,
                'city': city,
                'area': area,
                'per_page': perPage,
                'page': page,
            },
        });
    }
    /**
     * Get `prefectures` list.
     *
     * @param retailerId Retailer identifier
     * @param perPage Requested count
     * @param page Page number (permits to define offset, start at 1)
     * @returns any Successful operation, returning list.
     * @throws ApiError
     */
    public static getRetailersStoresPrefectures(
        retailerId: number,
        perPage?: number,
        page?: number,
    ): CancelablePromise<{
        /**
         * total entries length
         */
        total?: number;
        /**
         * returned page (start at 1)
         */
        page?: number;
        /**
         * count entries per page
         */
        per_page?: number;
        items?: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/retailers/{retailer_id}/stores/prefectures',
            path: {
                'retailer_id': retailerId,
            },
            query: {
                'per_page': perPage,
                'page': page,
            },
        });
    }
    /**
     * Get `cities` list.
     *
     * @param retailerId Retailer identifier
     * @param prefecture Prefecture name
     * @param perPage Requested count
     * @param page Page number (permits to define offset, start at 1)
     * @returns any Successful operation, returning list.
     * @throws ApiError
     */
    public static getRetailersStoresPrefecturesCities(
        retailerId: number,
        prefecture: string,
        perPage?: number,
        page?: number,
    ): CancelablePromise<{
        /**
         * total entries length
         */
        total?: number;
        /**
         * returned page (start at 1)
         */
        page?: number;
        /**
         * count entries per page
         */
        per_page?: number;
        items?: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/retailers/{retailer_id}/stores/prefectures/cities',
            path: {
                'retailer_id': retailerId,
            },
            query: {
                'prefecture': prefecture,
                'per_page': perPage,
                'page': page,
            },
        });
    }
    /**
     * Get `areas` list.
     *
     * @param retailerId Retailer identifier
     * @param prefecture Prefecture name
     * @param city City name
     * @param perPage Requested count
     * @param page Page number (permits to define offset, start at 1)
     * @returns any Successful operation, returning list.
     * @throws ApiError
     */
    public static getRetailersStoresPrefecturesCitiesAreas(
        retailerId: number,
        prefecture: string,
        city: string,
        perPage?: number,
        page?: number,
    ): CancelablePromise<{
        /**
         * total entries length
         */
        total?: number;
        /**
         * returned page (start at 1)
         */
        page?: number;
        /**
         * count entries per page
         */
        per_page?: number;
        items?: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/retailers/{retailer_id}/stores/prefectures/cities/areas',
            path: {
                'retailer_id': retailerId,
            },
            query: {
                'prefecture': prefecture,
                'city': city,
                'per_page': perPage,
                'page': page,
            },
        });
    }
}
